import { loadStripe } from "@stripe/stripe-js";

const {
  REACT_APP_API_URL,
  REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_CLIENT_SECRET,
  REACT_APP_URL,
} = process.env;

export const RECAPTCHA_KEY = `${REACT_APP_RECAPTCHA_SITE_KEY}`;

export const stripePromise = loadStripe(REACT_APP_CLIENT_SECRET || "");

export const URL = `${REACT_APP_URL}`;

export const AUTH_LOGIN = `${REACT_APP_API_URL}/api/Auth/login`;
export const AUTH_REGISTER_PARENT = `${REACT_APP_API_URL}/api/Auth/register/parent`;
export const CHECK_EXISTING_EMAIL = `${REACT_APP_API_URL}/api/auth/checkExistingEmail`;

export const COMMERCIAL_DOCUMENTS_API = `${REACT_APP_API_URL}/api/commercialDocuments`;
export const OUTSTANDING_INVOICE_API = `${REACT_APP_API_URL}/api/me/outstandingInvoice`;
export const PAYMENT_REF_API = `${REACT_APP_API_URL}/api/me/payment`;

export const CREATE_NEW_PAYMENTS_API = `${REACT_APP_API_URL}/api/payments`;
export const PAYMENTS_API = `${REACT_APP_API_URL}/api/payments`;

export const LIST_SCHOOLS_API = `${REACT_APP_API_URL}/api/schools`;
export const LIST_ACADEMIC_YEARS = `${REACT_APP_API_URL}/api/AcademicYears`;
export const LIST_LEVEL_SCHOOLS = `${REACT_APP_API_URL}/api/Levels`;
export const LIST_CLASS_SCHEDULES = `${REACT_APP_API_URL}/api/LevelGroups`;
export const LIST_STUDENT_SCHEDULES = `${REACT_APP_API_URL}/api/studentSchedules`;

export const STUDENTS_API = `${REACT_APP_API_URL}/api/students`;

export const PARENTS_API = `${REACT_APP_API_URL}/api/parents`;

export const SCHEDULES_API = `${REACT_APP_API_URL}/api/me/schedules`;

export const PROFILE_API = `${REACT_APP_API_URL}/api/me/profile`;

export const ACADEMIC_TERMS_API = `${REACT_APP_API_URL}/api/AcademicTerms`;

export const COST_PREVIEW_REGISTER_STUDENT = `${REACT_APP_API_URL}/api/costPreview/registerStudent`;

export const ONEMAP_API = "https://www.onemap.gov.sg/api/common/elastic/search";

export const ASSIGMENTS_API = `${REACT_APP_API_URL}/api/assignments`;

export const HOLIDAYS_API = `${REACT_APP_API_URL}/api/me/holidays`;

export const NOT_TAKING_REPORTS_API = `${REACT_APP_API_URL}/api/notTakingReports`;

export const FORGET_PASSWORD_API = `${REACT_APP_API_URL}/api/ForgotPassword`;

export const INVOICES_ME_API = `${REACT_APP_API_URL}/api/me/invoices`;

export const INVOICES_API = `${REACT_APP_API_URL}/api/invoices`;

export const SCHEDULE_PERMISSION = `${REACT_APP_API_URL}/api/me/children`;

export const PAYMENT_METHODS_API = `${REACT_APP_API_URL}/api/paymentMethods`;

export const CUSTOMERS_API = `${REACT_APP_API_URL}/api/customers`;

export const TIME_API = "https://use.ntpjs.org/v1/time.json";
